import { Currency, GetBasicReferralInfoResult, SuccessResult } from 'hydra-data-types';
import { CountryCode } from '../../helpers/GeoLocate';

/** A referral the backend has confirmed exists, with its flags. */
export type Referral = Omit<GetBasicReferralInfoResult, keyof SuccessResult | 'exists'> & {
  referralId: string;
};

/**
 * What is known about the user before the first screen, fixed for the session. `initializeApp` resolves
 * it once; cohort predicates and route selectors read it instead of the URL.
 */
export type EntryState = {
  country: CountryCode;
  /** The geolocated country's currency. **Not the user-selected currency**: that's `pricing.currency`. */
  currency: Currency;
  /** The confirmed referral. `undefined` for a Direct user. */
  referral: Referral | undefined;
  /** Arrived on the Re-engagement link (`entry=medicare-access`). */
  isReengagementLink: boolean;
  /** The ASL clinic's Stripe payment-link id (the `asl` URL param). */
  aslPaymentLinkId: string | undefined;
  /** The `coupon` URL param. */
  couponCode: string | undefined;
};

/** Before resolution, and the fallback when geolocation fails: AU keeps the US-only access flows closed. */
export const INITIAL_ENTRY_STATE: EntryState = {
  country: 'AU',
  currency: Currency.AUD,
  referral: undefined,
  isReengagementLink: false,
  aslPaymentLinkId: undefined,
  couponCode: undefined,
};
